import styled from '@emotion/styled';

import SwitchInput from 'components/field/SwitchInput';
import Form from 'components/form/Form';
import Typography from 'components/global/Typography';
import { ModalContent } from 'components/global/styled/Modal.styled';

import { Breakpoints } from 'utils/const.styles';

export const PriceContainer = styled.div`
	border-top: 1px solid var(--border-color);
	border-bottom: 1px solid var(--border-color);
	margin-top: 1rem;
	margin-bottom: 1rem;
`;

export const PriceContainerPosition = styled.div`
	position: absolute;
	bottom: 6rem;
	display: flex;
`;

export const PricePadding = styled(Typography)`
	padding-right: var(--padding-5);
	body[dir='rtl'] & {
		padding-right: 0;
		padding-left: var(--padding-5);
	}
`;

export const DiscountBadge = styled.div`
	text-align: right;
	padding: 0.3rem;
	color: #ebb947;
	background: var(--green-10);
	margin: 0 var(--margin-2);
	border-radius: var(--small-border-radius);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ModalContentWrapper = styled(ModalContent)`
	padding: 2rem 1rem 3rem 1rem;
`;

export const PromoCodeContainer = styled.div`
	display: flex;
	gap: 1.5rem;

	> .button {
		flex: 0 0 auto;
	}
`;

export const PaymentCard = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	width: 100%;
	padding: 1.5rem;
	overflow: hidden;

	:hover {
		cursor: pointer;
	}

	:active {
		cursor: default;
	}

	> * :hover {
		cursor: pointer;
	}

	> * :active {
		cursor: default;
	}
	> .icon.rotate {
		transition: all 0.5s ease;
		transform: rotate(270deg);
	}
	> .icon.rotate0 {
		transition: all 0.5s ease;
		transform: rotate(90deg);
	}
	&.collapse-header {
		border-top: 1px solid var(--border-color);
		margin-top: var(--padding-2);
		padding-top: var(--padding-5);
		justify-content: space-between;
	}
`;

export const CreditCardIFrameContainer = styled.div`
	padding-left: 3.5rem;
	body[dir='rtl'] & {
		padding-left: 0;
		padding-right: 3.5rem;
	}
`;

export const CompletedContainer = styled.div`
	padding-top: 4rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	.typography {
		text-align: center;
		line-height: 4rem;
		width: 80%;
	}
`;

// PackageSelection

export const MobileContainer = styled.div`
	@media ${Breakpoints.mobile} {
		height: 59dvh;
	}
`;
export const CardContainer = styled.div`
	position: relative;
	transition: all 0.3s ease-in-out;

	ul {
		padding: 0;
	}

	li {
		font-size: var(--paragraph3-font-size);
		list-style: none;
		padding-right: 0.5rem;
		margin-bottom: 1.7rem;
		span {
			margin-right: 0.5rem;
			body[dir='rtl'] & {
				margin-left: 0.5rem;
			}
		}
		color: var(--content-2);
	}
	li:last-of-type {
		margin-bottom: 0;
	}

	div.discountBadge {
		text-align: right;
		padding: 0.3rem;
		color: #ebb947;
		background: var(--green-10);
		margin: 0 var(--margin-2);
		border-radius: var(--small-border-radius);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.active {
		border: 1px solid var(--blue);
	}
	.activeBg {
		background: var(--blue);
	}
	.passiveBg {
		background: #bdbdbd;
	}
`;

export const UpgradeAccountPackage = styled.div`
	display: flex;
	flex-direction: column;
	background: var(--white);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	padding: 2rem;
	height: 100%;

	.priceMargin {
		margin-top: 4rem;
	}
`;

export const CurrentPlanStyle = styled.div`
	position: absolute;
	top: 4rem;
	color: var(--white);
	width: fit-content;
	padding: var(--padding-1);
	border-radius: var(--small-border-radius);
`;

export const ConfirmationDataBox = styled.div`
	gap: 1rem;
	border: 1px solid var(--border-color);
	margin: auto;
	border-radius: var(--small-border-radius);
	padding: var(--padding-4);
	> div {
		display: flex;
	}
	> div:first-of-type {
		border-bottom: 1px solid var(--border-color);
		padding-bottom: var(--padding-4);
	}
	> div:last-of-type {
		padding-top: var(--padding-4);
	}
`;

export const UserCardsContainer = styled.div`
	width: 100%;
	width: auto;
	display: grid;
	grid-template-columns: repeat(2, 0fr);
	gap: 1.5rem;
	padding: 1.5rem 1.5rem 1.5rem 0;
	margin-left: 3rem;
	overflow-x: auto;
	overflow-y: hidden;
	scroll-snap-type: x mandatory;
	scroll-behavior: smooth;
	-webkit-overflow-scrolling: touch;
	@media ${Breakpoints.mobile} {
		display: flex;
	}
	body[dir='rtl'] & {
		padding-right: 0;
		margin-right: 3rem;
		margin-left: 0;
	}
`;

export const CreditCardContainer = styled.div`
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	padding-left: var(--padding-4);
	body[dir='rtl'] & {
		padding-left: 0;
		padding-right: var(--padding-4);
	}
`;

export const InlineTypography = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
`;

export const BillingInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	padding: 1.5rem;
	overflow: hidden;
	border-top: 1px solid var(--border-color);
	margin-top: var(--padding-2);
	padding-top: var(--padding-5);
`;
export const DiscountContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: auto;
	padding: 0.25rem;
	gap: 0.5rem;

	background-color: var(--alert-success-bg);
	border: 1px solid #a1d872;
	border-radius: var(--small-border-radius);
`;

export const StyledForm = styled(Form)`
	border: 0;
	justify-content: center;
	padding: 0;
`;

export const ImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: var(--margin-2);
`;

export const TextCenterContainer = styled.div`
	text-align: center;
	margin-bottom: var(--margin-4);
`;

export const UpgradeConfirmationContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const TestCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	& > :not(:last-child) {
		border-bottom: 1px solid var(--border-color);
		padding-bottom: 1rem;
	}
`;

export const TestCard = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TestCardRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;

	.copy-area {
		background: transparent;
		border: none;
		max-width: 75%;
		justify-content: flex-end;
		width: fit-content;
		& > div {
			display: block;
			margin: 0;
		}
		.typography {
			margin-left: 0;
			body[dir='rtl'] & {
				margin-right: 0;
			}
		}
	}
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: flex-start;
		.copy-area {
			max-width: unset;
			justify-content: flex-start;
		}
	}
`;

export const Switch = styled(SwitchInput)`
	pointer-events: none;
`;
